import { GET_BROADCAST, ADD_BROADCAST } from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import moment from "moment";
export const getBroadcast = () => {
    return dispatch => {
        dispatch({ type: GET_BROADCAST.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/broadcast_list/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_BROADCAST.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_BROADCAST.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_BROADCAST.FAIL });
        }
    };
};
export const addBroadcast = news => {
    return dispatch => {
        news["timestamp"] = moment().format("DD-MM-YYYY HH:mm:ss");
        dispatch({ type: ADD_BROADCAST.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/broadcast_list/${news.timestamp}`)
                        .update(news);
                    dispatch({ type: ADD_BROADCAST.SUCCESS });
                } else dispatch({ type: ADD_BROADCAST.FAIL });
            });
        } catch {
            dispatch({ type: ADD_BROADCAST.FAIL });
        }
    };
};
